import axios from 'axios';
import { BEPI_API } from '../../../shared/config/bepiApiPaths';

// Backend resource path is @Path("web/client/equipment/..."), mounted under servlet /web/*
const BASE_URL = `${BEPI_API.client}/equipment`;

export const ClientEquipamentApi = {
  getEquipmentDetails: (id) => axios.get(`${BASE_URL}/${id}`),
  getEquipmentPhotos: (id) => axios.get(`${BASE_URL}/${id}/photos`),
  getEquipmentReports: (id) => axios.get(`${BASE_URL}/${id}/reports`),
  downloadReport: (fileName) => axios.get(`${BASE_URL}/api/laudos/${fileName}`, {
    responseType: 'blob'
  }),
  getEquipments: () => axios.get(BASE_URL),
  getPendingEquipments: () => axios.get(`${BASE_URL}/pending`),
  requestQuotation: (equipmentIds) => axios.post(`${BASE_URL}/request-quotation`, {
    equipmentIds,
  })
}
